module.exports = __webpack_public_path__ + "static/media/zilterWhiteLogo2.95b3857b.png";